module.exports = __webpack_public_path__ + "static/img/180605-feature-dr-lam-tak-sum.f55003c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/180605-feature-dr-lam-tak-sum.jpg
// module id = bWdb
// module chunks = 0